export const API_URL = "https://live.blogicitsolutions.in/";
export const CollectionUrl2 = `${API_URL}saved-detail/`;
export const CollectionUrl1 = `${API_URL}product-detail/`;
export const SaveRecievedUrl = `${API_URL}save-insert/`;
export const LATEST_ACCOUNTS_URL = (agentName) =>
  `${API_URL}latest-accounts/${agentName}/`;
// fetches all the saved receipts of multiple users
export const SAVED_URL = `${API_URL}saved-detail-user/`;

export const ACCOUNTS_LIST_URL = `${API_URL}accounts-list/`;

// ADD NEW ACCOUNT
export const ADD_NEW_ACCOUNT_URL = `${API_URL}add_new_account/`;

// GET NEW ACCOUNTS (latest)
export const GET_NEW_ACCOUNTS_URL = `${API_URL}get_new_accounts/`;

